import type { ReactNode } from 'react';

import appStrings from '@/assets/constants/appStrings-no.js';
import { routes } from '@/assets/constants/routes-no.ts';

export interface MenuLink {
  title: string;
  href: string;
  description?: string;
  /** Sized by the rendering menu, so pass the icon without size props. */
  icon?: ReactNode;
}

// export interface MenuGroup {
//   title: string;
//   children: MenuLink[];
// }

export type MenuItem = MenuLink; // | MenuGroup;

// export const isMenuGroup = (item: MenuItem): item is MenuGroup => 'children' in item;

// /** Groups become their children, in config order, so drawers can stay a flat list. */
// export const flattenMenuLinks = (items: MenuItem[]): MenuLink[] =>
//   items.flatMap((item) => (isMenuGroup(item) ? item.children : [item]));

export const useMenuItems = (): MenuItem[] => {
  return [
    {
      title: 'Refinansiering',
      href: routes.PRODUCTS_REFINANCING,
    },
    {
      title: 'Forbrukslån',
      description: 'Få tilbud fra flere banker',
      href: routes.CONSUMER_LOAN,
    },
    {
      title: 'Kredittkort',
      href: routes.CREDIT_CARDS,
    },
    {
      title: 'Kampanjer',
      href: routes.COMPETITION_WINNERS,
    },
    {
      title: appStrings.MENU.CUSTOMER_SERVICE,
      href: routes.CUSTOMER_SERVICE,
    },
  ];
};
